"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _config = _interopRequireDefault(require("webmotors-react-pj/i18n/config"));
var _style = require("webmotors-react-pj/frame/footer/logged/brands/style");
var _default = () => _react.default.createElement(_style.StyleSign, null, _react.default.createElement(_style.StyleImgWebmotors, {
  "aria-hidden": "true",
  alt: "",
  src: _config.default.footer.logoWebmotors
}), _react.default.createElement(_style.StyleImgSantander, {
  "aria-hidden": "true",
  alt: "",
  src: _config.default.footer.logoSantander
}));
exports.default = _default;